import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

export default function AdminLoader() {
  // Use `useSelector` to access the `isLoading` state from the Redux store
  const isLoading = useSelector((state) => state.site.isLoading);
  // const isLoading = true;
  const [loaderPercentage, setLoaderPercentage] = useState(0);
  const [intervalSpeed, setIntervalSpeed] = useState(50); // Initial speed for quick start

  useEffect(() => {
    let interval = null; // Initialize interval as `null`

    if (isLoading) {
      // Start the interval for loader percentage increment
      interval = setInterval(() => {
        setLoaderPercentage((prev) => {
          // Gradually slow down the progress as it reaches 90%
          if (prev < 95) {
            // Increase the step size as `prev` increases, slowing down over time
            if (prev < 60) {
              setIntervalSpeed(10); // Fast for the first 30%
              return prev + 0.1;
            } else if (prev < 70) {
              setIntervalSpeed(20); // Slow down for the next 30%
              return prev + 0.1;
            } else if (prev < 95 && prev >= 90) {
              setIntervalSpeed(40); // Slowest for the final 30%
              return prev + 0.01;
            }
            return prev + 0.1;
          } else {
            return prev;
          }
        });
      }, intervalSpeed); // Use dynamic interval speed for gradual slow down
    } else {
      // If not loading, complete the last 10% quickly
      setLoaderPercentage(100);

      // Clear the interval if it exists
      if (interval) clearInterval(interval);

      setTimeout(() => {
        setLoaderPercentage(0); // Reset loader to 0% when completed
      }, 200); // Complete the last 10% in 200ms
    }

    // Cleanup function
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isLoading, intervalSpeed]); // Add `intervalSpeed` to dependencies

  return (
    <>
      {isLoading && (
        <div className={`adminLoader ${isLoading ? "active" : ""}`}>
          <div
            className="loader-bar"
            style={{ width: `${loaderPercentage}%` }}
          />
        </div>
      )}
    </>
  );
}
